import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

import $ from 'jquery';
import LabelInput from '../../elements/LabelImput';
import { injectPhpDebug } from '../../../../mol_function';

import './index.scss';
import AdressComponnent, {
  AdressComponnentProp,
  getEmptyAddressProp,
} from '../../elements/AdressComponnent';
import AdressPicker from '../../elements/AdressPicker';
import PasswordInput from '../../elements/PasswordInput';
import BuchhandlerInput from '../../elements/BuchhandlerInput';

import img_BAG from '../Checkout_VR/parts/images/BAG.svg.png';
import img_BUCH_RECHNUNG from '../Checkout_VR/parts/images/buchbutler_rechnungskauf.png';

import { translateAdressApiToModelExtern } from '../Checkout_VR';

interface CheckoutState extends BasePageState {
  checkoutID?: string;
  validEmail?: boolean;
  enableNext: boolean;
  enableBussy: boolean;
  billingAddress?: AdressComponnentProp;
  schippingAddress?: AdressComponnentProp;
  adressBook: any[];
  isBillingAdressValid: boolean;
  isSchippingAdressValid: boolean;
  isBuchhandlerValid: boolean;
  loginError: boolean;
  pendingReqest?: Promise<Response>;
  newSchippingLiefertage: number[];
  paymentItem?: {
    paymentType: string;
    orderGUID: string;
    checkOutReady: boolean;
  };
}

interface CheckoutModel {}

export default class CheckoutPage extends Basepage<
  CheckoutState,
  CheckoutModel
> {
  constructor(prop: CheckoutModel) {
    super(prop);
  }

  onEmailReady() {
    if (this.state.pendingReqest != undefined) {
      return;
    }

    this.setState({ enableNext: false });
    let email = $('#email').val();
    if (email != undefined && typeof email === 'string') {
      if (email.trim() == '') {
        return;
      }
      let apiUrl = injectPhpDebug(
        this.state.apiBase +
          '/Checkout.php?checkEmail=' +
          encodeURIComponent(email),
      );

      let reqest = fetch(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      this.setState({ pendingReqest: reqest });

      reqest
        .then((response) => response.json())
        .then((data) => {
          let validEmail: boolean = data.body.validEmail;
          let newState: any = {
            validEmail: validEmail,
            billingAddress: undefined,
            loginError: true,
            pendingReqest: undefined,
          };

          if (!validEmail) {
            // Neuer Kunde: leeres Rechnungsadresse-Formular anzeigen
            let newAdress =
              this.state.billingAddress != undefined
                ? this.state.billingAddress
                : getEmptyAddressProp(this.state.apiData.body.countrys);
            newState.billingAddress = newAdress;
            newState.loginError = false;
          }
          this.setState(newState);
        });
    }
  }

  onPasswordReady() {
    this.setState({ enableNext: false });
    let email = $('#email').val();
    let pass = $('#login-password').val();
    if (
      email != undefined &&
      (typeof email === 'string' || email instanceof String) &&
      pass != undefined &&
      (typeof pass === 'string' || pass instanceof String)
    ) {
      let apiUrl = injectPhpDebug(
        this.state.apiBase +
          '/Checkout.php?tryLogin=' +
          encodeURIComponent(email) +
          '&pass=' +
          encodeURIComponent(pass),
      );

      fetch(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
        .then((response) => response.json())
        .then((data) => {
          let loginSuccess = data.body.loginSucess;
          let newState: any = {};
          newState.billingAddress = undefined;
          newState.schippingAddress = undefined;
          newState.loginError = !loginSuccess;

          if (loginSuccess) {
            newState.apiData = data.body;
            let parsed = this.parseApiDataForState(data.body);
            newState.billingAddress = parsed.billingAddress;
            newState.schippingAddress = parsed.schippingAddress;
            newState.isBillingAdressValid =
              parsed.billingAddress?.adress_id != undefined;
            newState.isSchippingAdressValid =
              parsed.schippingAddress?.adress_id != undefined;
            newState.newSchippingLiefertage = this.parseShipmentdays(
              parsed.shippingTage,
            );
            newState.adressBook = parsed.adressBook;
            newState.isBuchhandlerValid = parsed.isValidBuchhandler;
          }
          this.setState(newState);
        });
    }
  }

  formToObject() {
    let form = $('#checkoutForm');
    let formSerializeData = form.serialize();
    let keyValuePair = formSerializeData.split('&');
    let result: any = {};
    for (let i = 0; i < keyValuePair.length; i++) {
      let kvSplit = keyValuePair[i].split('=');
      if (kvSplit[1].trim() != '') result[kvSplit[0]] = decodeURI(kvSplit[1]);
      else result[kvSplit[0]] = null;
    }
    return result;
  }

  onPaymentChange(payment: string) {
    let apiUrl = injectPhpDebug(
      this.state.apiBase +
        '/Checkout.php?changePayment=' +
        encodeURIComponent(payment),
    );

    let result = this.formToObject();

    let jsonBody = JSON.stringify(result);

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: jsonBody,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.REDIRECT != undefined) {
          let winAny: any = window;
          winAny.historyHelper.memory.push(data.REDIRECT, null);
        } else {
          let paymentType = data.body.paymentType;
          let orderGUID: string = data.body.orderGUID;

          this.setState({
            paymentItem: {
              paymentType: paymentType,
              orderGUID: orderGUID,
              checkOutReady: true,
            },
          });

          setTimeout(() => {
            if (this.state.paymentItem != undefined) {
              let htmlItem = document.getElementById('formContainer');
              let jsItem = document.getElementById('jsScriptContainer');
              if (htmlItem != null && jsItem != null) {
                htmlItem.innerHTML = '';
                jsItem.innerHTML = '';

                if (paymentType == 'BAG') {
                  let img = document.createElement('img');
                  img.setAttribute('src', img_BAG);
                  img.style.height = '120px';
                  htmlItem.append(img);
                } else if (paymentType == 'BUCH_RECHNUNG') {
                  let img = document.createElement('img');
                  img.setAttribute('src', img_BUCH_RECHNUNG);
                  img.style.height = '120px';
                  htmlItem.append(img);
                } else if (paymentType == 'TEST') {
                  let sp = document.createElement('span');
                  sp.innerText = 'TEST';
                  sp.style.height = '120px';
                  htmlItem.append(sp);
                }
              }
            }
          }, 500);
        }
      });
  }

  renderLiefertageBox(): JSX.Element {
    return (
      <div className="liefertageBox">
        <span>Liefertage:</span>
        <input
          type="hidden"
          name="schipping_liefertage"
          value={this.state.newSchippingLiefertage.join(',')}
        />
        {(['Mo', 'Di', 'Mi', 'Do', 'Fr'] as const).map((day, idx) => (
          <label key={idx} className="liefertageLabel">
            <input
              type="checkbox"
              value={idx}
              checked={this.state.newSchippingLiefertage.includes(idx)}
              onChange={(ev) => {
                let tage = this.state.newSchippingLiefertage.slice();
                if (ev.target.checked) {
                  tage.push(idx);
                } else {
                  tage = tage.filter((d) => d !== idx);
                }
                this.setState({ newSchippingLiefertage: tage });
              }}
            />
            {day}
          </label>
        ))}
      </div>
    );
  }

  createPayRadio(name: string) {
    let images = {
      BAG: img_BAG,
      BUCH_RECHNUNG: img_BUCH_RECHNUNG,
    };
    let imagesSrc = images[name];
    return (
      <>
        <input
          type="radio"
          name={'payMethod'}
          tabIndex={1}
          id={'payMethod_' + name}
          value={name}
          className="radioPos"
          onChange={(ev) => {
            let paymentMethod = ev.target.value;
            this.onPaymentChange(paymentMethod);
          }}
        />
        <label htmlFor={'payMethod_' + name}>
          {imagesSrc != undefined ? (
            <img src={imagesSrc} />
          ) : (
            <span className="payment_label">{name}</span>
          )}
        </label>
      </>
    );
  }

  renderChild(): JSX.Element {
    let isLogin = this.state.apiData.isLogin;
    let billingAddress = this.state.billingAddress;

    if (billingAddress == undefined) {
      billingAddress = {} as AdressComponnentProp;
      billingAddress.countrys = this.state.apiData.body?.countrys ?? [];
      billingAddress.country_id = 81; // Default auf Deutschland
    }

    let billingApiItem = (this.state.apiData.body?.addresse ?? []).find(
      (f: any) => f.adress_id == billingAddress?.adress_id,
    );
    let billingIsNotShipping =
      billingApiItem != undefined && !billingApiItem.isShippingAddress && false;

    let showBag = false;
    if (this.state.apiData.body?.BAG_ERLAUBT == true) {
      showBag = true;
    }

    let isBuchhandlerValid = this.state.isBuchhandlerValid || isLogin;

    let showPaymentBox =
      this.state.isBillingAdressValid &&
      (this.state.schippingAddress == undefined ||
        (this.state.schippingAddress != undefined &&
          this.state.isSchippingAdressValid)) &&
      isBuchhandlerValid;

    let ErrorMessage = '';
    if (!showPaymentBox) {
      if (!this.state.isBillingAdressValid) {
        ErrorMessage +=
          'Ihre Rechnungsadresse ist nicht vollständig. Bitte wählen Sie eine Anrede.\n';
      }
      if (
        this.state.schippingAddress != undefined &&
        !this.state.isSchippingAdressValid
      ) {
        ErrorMessage +=
          'Ihre Lieferadresse ist nicht vollständig. Bitte wählen Sie eine Anrede.\n';
      }
      if (!isBuchhandlerValid) {
        ErrorMessage +=
          'Bitte bestätigen Sie, dass Sie als Buchhändler tätig sind.\n';
      }
    }

    let showAdress =
      this.state.validEmail === false ||
      (this.state.validEmail === true && this.state.loginError === false);

    // jQuery braucht ein document, im SSR gibt es keins
    let showLoginError =
      typeof document != 'undefined' &&
      ($('#login-password').val()?.toString() ?? '').trim() != '';

    return (
      <div id="checkout">
        <form
          id="checkoutForm"
          onSubmit={(event) => {
            event.preventDefault();
          }}
        >
          {isLogin == false ? (
            <>
              <LabelInput
                id="email"
                labelText="E-Mail Adresse"
                type="text"
                name="email"
                inputDynparam={{ size: 36, maxLength: 96 }}
                requied={true}
                onChange={(ev) => {}}
                onBlur={(ev) => {
                  this.onEmailReady();
                }}
              />
              {this.state.validEmail ? (
                <PasswordInput
                  onBlur={(ev) => {
                    this.onPasswordReady();
                  }}
                  showLost={true}
                />
              ) : this.state.validEmail == false ? (
                <BuchhandlerInput
                  isNotValidExit={true}
                  cookieDomain={this.state.apiData.cookieDomain}
                  isValidNotify={(valid) => {
                    this.setState({ isBuchhandlerValid: valid });
                  }}
                />
              ) : null}
              {this.state.loginError && showLoginError && showLoginError ? (
                <span>Fehler beim Anmelden</span>
              ) : null}
            </>
          ) : null}
          {showAdress ? (
            <>
              <fieldset className="fsWidth_L">
                <legend>
                  Rechnungsanschrift
                  {this.state.schippingAddress == undefined
                    ? ' und Lieferanschrift'
                    : ''}
                </legend>
                {(this.state.adressBook?.length ?? 0) >= 1 ? (
                  <AdressPicker
                    list={(this.state.adressBook ?? []).filter(
                      (item) => item.isBillingAddress,
                    )}
                    selectedId={this.state.billingAddress?.adress_id}
                    showNewCard={true}
                    onSelect={(newId) => {
                      let apiData = this.state.apiData.body;
                      if (newId === 'new') {
                        this.setState({
                          billingAddress: getEmptyAddressProp(apiData.countrys),
                        });
                      } else {
                        let apiItem = apiData.addresse.find(
                          (f: any) => f.adress_id == newId,
                        );
                        let newBilling = translateAdressApiToModelExtern(
                          apiItem,
                          apiData.countrys,
                          false,
                        );
                        this.setState({
                          billingAddress: newBilling,
                          isBillingAdressValid: true,
                        });
                      }
                    }}
                    isLieferTermin={this.state.schippingAddress == undefined}
                  />
                ) : null}

                {billingAddress?.adress_id != undefined ? (
                  <input
                    type="hidden"
                    name="adress_id_billig"
                    value={billingAddress.adress_id}
                  />
                ) : (
                  <>
                    <AdressComponnent
                      {...billingAddress}
                      idPostfix="_billig"
                      isValidNotify={(isValid) => {
                        if (this.state.isBillingAdressValid != isValid) {
                          this.setState({ isBillingAdressValid: isValid });
                        }
                      }}
                    />
                    {this.state.schippingAddress == undefined &&
                      this.renderLiefertageBox()}
                    {this.state.isBillingAdressValid != true ? (
                      <span
                        className="errorText"
                        style={{ fontWeight: 'bold', fontSize: 'x-large' }}
                      >
                        *Bitte alle Pflichtfelder ausfüllen
                      </span>
                    ) : (
                      <>
                        {isLogin ? (
                          <button
                            style={{ float: 'right' }}
                            onClick={() => {
                              this.saveAdressToDb(true);
                            }}
                          >
                            Speichen
                          </button>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </fieldset>

              {showPaymentBox ? (
                <fieldset className="paymentPos">
                  <legend>Wählen Sie ihre Zahlungsart</legend>
                  <div className="paymentBox">
                    {this.createPayRadio('BUCH_RECHNUNG')}
                    {showBag ? this.createPayRadio('BAG') : null}
                    {/* 
                    {this.createPayRadio('TEST')} 
                    */}
                  </div>
                </fieldset>
              ) : (
                <div>
                  {ErrorMessage.split('\n')
                    .filter((m) => m.trim() != '')
                    .map((m) => {
                      m;
                    })
                    .reduce((prev, next) => (
                      <>
                        {prev}
                        <br />
                        {next}
                      </>
                    ))}
                </div>
              )}

              <br className="clearBoth" />

              <input
                type="checkbox"
                onChange={(ev) => {
                  //if (billingIsNotShipping) return;
                  let newState: any = {};
                  if (ev.target.checked) {
                    let apiData = this.state.apiData.body;
                    let defaultSchipping = apiData.addresse?.find(
                      (f: any) => f.isShippingDefault,
                    );
                    if (
                      defaultSchipping != undefined &&
                      defaultSchipping.adress_id !=
                        this.state.billingAddress?.adress_id
                    ) {
                      newState.schippingAddress =
                        translateAdressApiToModelExtern(
                          defaultSchipping,
                          apiData.countrys,
                          false,
                        );
                      newState.isSchippingAdressValid = true;
                      newState.newSchippingLiefertage = this.parseShipmentdays(
                        defaultSchipping.sammlung_shipmentdays,
                      );
                    } else {
                      newState.schippingAddress = getEmptyAddressProp(
                        apiData.countrys,
                      );
                      newState.isSchippingAdressValid = false;
                      newState.newSchippingLiefertage =
                        this.state.newSchippingLiefertage;
                    }
                  } else {
                    newState.schippingAddress = undefined;
                    newState.newSchippingLiefertage = [];
                  }
                  this.setState(newState);
                }}
                name="diffSchippingAddress"
                checked={
                  this.state.schippingAddress != undefined ||
                  billingIsNotShipping
                }
                disabled={billingIsNotShipping}
              />

              <span>Abweichende Lieferanschrift?</span>
              <br className="clearBoth" />

              {this.state.schippingAddress ? (
                <fieldset className="fsWidth">
                  <legend>Lieferanschrift</legend>
                  {(this.state.adressBook?.length ?? 0) >= 1 ? (
                    <AdressPicker
                      list={(this.state.adressBook ?? []).filter(
                        (item) => item.isShippingAddress,
                      )}
                      selectedId={this.state.schippingAddress?.adress_id}
                      showNewCard={true}
                      onSelect={(newId) => {
                        let apiData = this.state.apiData.body;
                        if (newId === 'new') {
                          this.setState({
                            schippingAddress: getEmptyAddressProp(
                              apiData.countrys,
                            ),
                          });
                        } else {
                          let apiItem = apiData.addresse.find(
                            (f: any) => f.adress_id == newId,
                          );
                          let newSchipping = translateAdressApiToModelExtern(
                            apiItem,
                            apiData.countrys,
                            false,
                          );
                          this.setState({
                            schippingAddress: newSchipping,
                            isSchippingAdressValid: true,
                          });
                        }
                      }}
                      isLieferTermin={true}
                    />
                  ) : null}

                  {this.state.schippingAddress?.adress_id != undefined ? (
                    <input
                      type="hidden"
                      name="adress_id_schipping"
                      value={this.state.schippingAddress.adress_id}
                    />
                  ) : (
                    <>
                      <AdressComponnent
                        {...this.state.schippingAddress}
                        idPostfix="_schipping"
                        isCompanyNotRequired={true}
                        isValidNotify={(isValid) => {
                          if (this.state.isSchippingAdressValid != isValid) {
                            this.setState({ isSchippingAdressValid: isValid });
                          }
                        }}
                      />
                      {this.renderLiefertageBox()}
                      {this.state.isSchippingAdressValid != true ? (
                        <span
                          className="errorText"
                          style={{ fontWeight: 'bold', fontSize: 'x-large' }}
                        >
                          *Bitte alle Pflichtfelder ausfüllen
                        </span>
                      ) : (
                        <>
                          {isLogin ? (
                            <button
                              style={{ float: 'right' }}
                              onClick={() => {
                                this.saveAdressToDb(false);
                              }}
                            >
                              Speichen
                            </button>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </fieldset>
              ) : null}
              <br />
            </>
          ) : null}
        </form>

        {this.state.paymentItem != undefined ? (
          <div className="checkoutPopup">
            <div className="payment">
              <div
                className="closePopoup"
                onClick={() => {
                  this.setState({ paymentItem: undefined });
                  $('input[name=payMethod]').prop('checked', false);
                }}
              >
                X
              </div>
              <div>
                <h3>Kauf abschließen mit:</h3>
              </div>
              <div id="jsScriptContainer"></div>
              <div id="formContainer"></div>
              <button
                onClick={() => {
                  if (this.state.paymentItem != undefined) {
                    let callBack =
                      '/paymentResult?paymentType=' +
                      this.state.paymentItem.paymentType +
                      '&orderGUID=' +
                      this.state.paymentItem.orderGUID;
                    let windowAny: any = window;

                    if (
                      windowAny.historyHelper != undefined &&
                      windowAny.historyHelper.browser != undefined
                    ) {
                      windowAny.historyHelper.browser.push(callBack);
                    }
                  }
                }}
              >
                Kauf Abschließen
              </button>
            </div>
          </div>
        ) : null}

        {this.state.enableBussy == false &&
        this.state.billingAddress == undefined ? (
          <>
            <br className="clearBoth" />
            <button
              disabled={this.state.enableNext}
              onClick={() => {
                if (this.state.validEmail == undefined) {
                  this.onEmailReady();
                } else {
                  this.onPasswordReady();
                }
              }}
            >
              Weiter
            </button>
          </>
        ) : null}
      </div>
    );
  }

  initState(base: BasePageState): CheckoutState {
    let anyProps: any = this.props;
    let apiData = anyProps.apiData;

    let apiPackage = this.parseApiDataForState(apiData);
    let isBillingAdressValid =
      apiPackage?.billingAddress?.adress_id != undefined;

    let newState: CheckoutState = {
      ...base,
      isBillingAdressValid: isBillingAdressValid,
      isSchippingAdressValid:
        apiPackage?.schippingAddress?.adress_id != undefined,
      checkoutID: undefined,
      validEmail: undefined,
      enableNext: false,
      enableBussy: false,
      loginError: false,
      newSchippingLiefertage: this.parseShipmentdays(apiPackage.shippingTage),
      billingAddress: apiPackage.billingAddress,
      schippingAddress: apiPackage.schippingAddress,
      isBuchhandlerValid: apiPackage.isValidBuchhandler,
      adressBook: apiPackage.adressBook,
    };

    return newState;
  }

  saveAdressToDb(isBilling: boolean): void {
    let adressType = isBilling ? 'billig' : 'schipping';

    let apiUrl = injectPhpDebug(
      this.state.apiBase + '/Checkout.php?saveAdress=' + adressType,
    );

    let result = this.formToObject();

    let jsonBody = JSON.stringify(result);

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: jsonBody,
    })
      .then((response) => response.json())
      .then((data) => {
        let isBilling_copy = adressType == 'billig';
        let newId = data.body.newAdress.adress_id;

        let newState: any = {};
        newState.adressBook = data.body.addresse;

        if (isBilling_copy) {
          let billingAdressApi = newState.adressBook.find(
            (f: any) => f.adress_id == newId,
          );

          let billingAddress = translateAdressApiToModelExtern(
            billingAdressApi,
            data.body.countrys,
            false,
          );
          newState.billingAddress = billingAddress;
          newState.isBillingAdressValid = true;
        } else {
          let schippingAdressApi = newState.adressBook.find(
            (f: any) => f.adress_id == newId,
          );

          let schippingAddress = translateAdressApiToModelExtern(
            schippingAdressApi,
            data.body.countrys,
            false,
          );
          newState.schippingAddress = schippingAddress;
          newState.isSchippingAdressValid = true;
        }

        this.setState(newState);
      });
  }

  parseShipmentdays(raw: string | null | undefined): number[] {
    if (!raw) return [0, 1, 2, 3, 4];
    return raw
      .split(',')
      .map((d) => parseInt(d.trim()))
      .filter((d) => !isNaN(d));
  }

  parseApiDataForState(apiData: any): {
    isLogin: boolean;
    billingAddress: AdressComponnentProp | undefined;
    schippingAddress: AdressComponnentProp | undefined;
    isValidBuchhandler: boolean;
    adressBook: [];
    shippingTage: string;
  } {
    let isLogin: boolean = false;
    let billingAddress: AdressComponnentProp | undefined = undefined;
    let schippingAddress: AdressComponnentProp | undefined = undefined;

    if (apiData != null) {
      isLogin = apiData.isLogin;
    }
    let isValidBuchhandler = false;
    let shippingTage = apiData?.body?.default_shipmentdays ?? '0,1,2,3,4';

    if (isLogin) {
      isValidBuchhandler = true;
      let billingAdressApi = apiData.body.addresse?.find(
        (f) => f.isBillingDefault,
      );

      /*
      if (billingAdressApi == undefined && apiData.body.addresse?.length > 0) {
        billingAdressApi = apiData.body.addresse[0];
      }
      */

      if (billingAdressApi != undefined) {
        billingAddress = translateAdressApiToModelExtern(
          billingAdressApi,
          apiData.body.countrys,
          false,
        );

        let schippingAdressApi = apiData.body.addresse?.find(
          (f) => f.isShippingDefault,
        );

        if (
          schippingAdressApi != undefined &&
          billingAdressApi.adress_id != schippingAdressApi.adress_id
        ) {
          schippingAddress = translateAdressApiToModelExtern(
            schippingAdressApi,
            apiData.body.countrys,
            false,
          );
        }
      }
    }

    return {
      isLogin: isLogin,
      billingAddress: billingAddress,
      schippingAddress: schippingAddress,
      isValidBuchhandler: isValidBuchhandler,
      adressBook: apiData?.body?.addresse ?? [],
      shippingTage: shippingTage,
    };
  }

  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Checkout.php';
  }

  releaseOneCommand(): void {}

  childDidMount(): void {
    if (this.state.hasApiData) {
      let prepared = this.parseApiDataForState(this.state.apiData);
      if (
        this.state.billingAddress != prepared.billingAddress ||
        this.state.schippingAddress != prepared.schippingAddress
      ) {
        this.setState({
          billingAddress: prepared.billingAddress,
          schippingAddress: prepared.schippingAddress,
          isBuchhandlerValid: prepared.isValidBuchhandler,
          newSchippingLiefertage: this.parseShipmentdays(prepared.shippingTage),
          adressBook: prepared.adressBook,
        });
      }
    }
  }

  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {
    if (prevState.hasApiData == false && this.state.hasApiData == true) {
      let prepared = this.parseApiDataForState(this.state.apiData);

      let newstate: any = {};

      if (this.state.apiData.isLogin) {
        newstate.validEmail = true;
      }
      newstate.billingAddress = prepared.billingAddress;
      newstate.isBillingAdressValid =
        prepared.billingAddress?.adress_id != undefined;
      newstate.schippingAddress = prepared.schippingAddress;
      newstate.isSchippingAdressValid =
        prepared.schippingAddress?.adress_id != undefined;
      newstate.newSchippingLiefertage = this.parseShipmentdays(
        prepared.shippingTage,
      );
      newstate.adressBook = prepared.adressBook;
      this.setState(newstate);
    }
  }
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Kasse';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Kasse</span>;
  }
  getType(): string {
    return 'CheckoutPage';
  }
}
